// extracted by mini-css-extract-plugin
export default {"custom-scrollbar":"drawer_custom-scrollbar__Tv74Y"};